import React, { useState, useEffect } from 'react';

const ReturnSheet = ({ conversations, onSelect, onClose }) => {
  const [isVisible, setIsVisible] = useState(false);
  const recent = conversations.slice(0, 5);

  useEffect(() => {
    requestAnimationFrame(() => setIsVisible(true));
  }, []);

  const handleClose = () => {
    setIsVisible(false);
    setTimeout(onClose, 300);
  };

  const handleSelect = (id) => {
    setIsVisible(false);
    setTimeout(() => onSelect(id), 300);
  };

  const formatDate = (dateStr) => {
    const d = new Date(dateStr);
    return d.toLocaleDateString('en-US', { month: 'short', day: 'numeric' });
  };

  return (
    <div
      data-testid="return-sheet-overlay"
      onClick={handleClose}
      style={{
        position: 'fixed',
        inset: 0,
        zIndex: 60,
        background: isVisible ? 'rgba(0, 0, 0, 0.5)' : 'transparent',
        transition: 'background 0.3s ease'
      }}
    >
      {/* Sheet */}
      <div
        data-testid="return-sheet"
        onClick={(e) => e.stopPropagation()}
        style={{
          position: 'absolute',
          bottom: 0,
          left: 0,
          right: 0,
          background: '#080608',
          borderRadius: '20px 20px 0 0',
          padding: '16px 0 40px 0',
          transform: isVisible ? 'translateY(0)' : 'translateY(100%)',
          transition: 'transform 0.5s cubic-bezier(0.32, 0.72, 0, 1)',
          maxHeight: '75vh'
        }}
      >
        {/* Drag handle */}
        <div style={{ display: 'flex', justifyContent: 'center', marginBottom: '24px' }}>
          <div style={{
            width: '40px',
            height: '4px',
            borderRadius: '100px',
            background: 'rgba(255, 243, 225, 0.15)'
          }} />
        </div>

        {/* Title */}
        <p
          data-testid="return-sheet-title"
          style={{
            textAlign: 'center',
            fontFamily: "'Cormorant', Georgia, serif",
            fontSize: '18px',
            fontWeight: 300,
            fontStyle: 'italic',
            color: 'rgba(255, 243, 225, 0.45)',
            margin: '0 0 24px 0'
          }}
        >
          where would you like to return?
        </p>

        {/* Conversation rows */}
        <div style={{ padding: '0 32px' }}>
          {recent.length === 0 ? (
            <p style={{
              textAlign: 'center',
              fontFamily: "'Cormorant', Georgia, serif",
              fontSize: '15px',
              fontStyle: 'italic',
              color: 'rgba(255, 243, 225, 0.25)',
              padding: '20px 0'
            }}>
              no conversations yet
            </p>
          ) : (
            recent.map((conv) => (
              <button
                key={conv.id}
                data-testid={`return-row-${conv.id}`}
                onClick={() => handleSelect(conv.id)}
                className="return-row"
                style={{
                  display: 'block',
                  width: '100%',
                  minHeight: '68px',
                  padding: '14px 0',
                  background: 'transparent',
                  border: 'none',
                  borderBottom: '1px solid rgba(255, 243, 225, 0.06)',
                  cursor: 'pointer',
                  textAlign: 'left',
                  transition: 'background 0.2s ease',
                  WebkitTapHighlightColor: 'transparent'
                }}
              >
                <p style={{
                  fontFamily: "'EB Garamond', Georgia, serif",
                  fontSize: '18px',
                  fontWeight: 400,
                  color: 'rgba(255, 243, 225, 0.85)',
                  margin: 0,
                  lineHeight: 1.4
                }}>
                  {conv.title || 'Untitled conversation'}
                </p>
                <p style={{
                  fontFamily: "'EB Garamond', Georgia, serif",
                  fontSize: '13px',
                  fontWeight: 400,
                  color: 'rgba(255, 243, 225, 0.30)',
                  margin: '4px 0 0 0'
                }}>
                  {formatDate(conv.updated_at || conv.created_at)}
                </p>
              </button>
            ))
          )}
        </div>
      </div>

      <style>{`
        .return-row:active {
          background: rgba(196, 137, 74, 0.06) !important;
        }
      `}</style>
    </div>
  );
};

export default ReturnSheet;
